import { Component, inject, OnDestroy, signal } from '@angular/core';
import { CommonService } from 'src/app/services/common.service';
import * as moment from "moment-timezone";
import { AgeGateService } from 'src/app/services/age-gate.service';

@Component({
  selector: 'app-age-verify',
  templateUrl: './age-verify.component.html',
  styleUrls: ['./age-verify.component.css']
})
export class AgeVerifyComponent implements OnDestroy {
  private commonService = inject(CommonService)
  public ageGate = inject(AgeGateService)
  storeList = signal([])
  ageVerification: any = ''
  bgImage: any = ''
  ngOnInit(): void {
    this.getData()
    this.getStoreList()
  }

  getData(): void {
    this.commonService.Get('/websitesetup/ageverification').subscribe(({ meta, homePageContent }) => {
      if (!meta?.status || !homePageContent?.ageVerification) {
        return;
      }
      const ageVerification = homePageContent.ageVerification;

      this.ageVerification = ageVerification;
      this.bgImage = ageVerification.bgImage || 'assets/images/bg1.jpg';
    });
  }


  confirmAge() {
    this.ageGate.confirm();
  }

  denyAge() {
    this.ageGate.deny();
  }

  getStoreList() {
    this.commonService.pickUpStoreAll().subscribe((res) => {
      if (res['meta']['status']) {
        let store: any = res['data'][0];
        localStorage.setItem("storeInfo", JSON.stringify(store));
        localStorage.setItem("localStoreId", store?.Id);
        localStorage.setItem("storeCurrentAddress", store?.Address?.AddressLine2);
        localStorage.setItem("addressString", store?.Address?.AddressLine2);
        localStorage.setItem("addressForOrderPlace", store?.Address?.AddressLine2);
        localStorage.setItem("addressStatus", "true");
        localStorage.setItem("addressLatitude", store?.location?.coordinates[1]);
        localStorage.setItem("addressLongitude", store?.location?.coordinates[0]);
        localStorage.setItem("postal_code", store?.Address?.Zip);
        localStorage.setItem("city", store?.Address?.City);
        localStorage.setItem("country", store?.Address?.CountryName);
        localStorage.setItem("countryCode", 'US');
        localStorage.setItem("dilveryStatus", "true");
        localStorage.setItem("localStoreName", store?.Name);
        localStorage.setItem("isPickUpOrder", 'true'),
          this.storess(store)
      }
    });
  }


  storess(store) {
    const weekday = moment().format('dddd');

    const storeHours = store?.StoreHours?.[weekday];
    const openTime = moment().hour(storeHours.Open.Hour).minute(storeHours.Open.Minute);
    let closeTime = moment().hour(storeHours.Close.Hour).minute(storeHours.Close.Minute);

    if (closeTime.isSameOrBefore(openTime)) {
      closeTime.add(1, 'day');
    }
    localStorage.setItem('storeTiming', JSON.stringify(storeHours));
  }

  ngOnDestroy() {
    document.body.style.overflow = '';
  }

}
